import { mapState, mapActions } from 'vuex'
import { $EventBus } from '@/main'

export default {
  name: 'AreaCascader',

  props: {
    value: { type: Object, default: null }
  },

  data() {
    return {
      loadingArea: false,
      selectedArea: null,
      selectedClassification: null,
      subtypeLevels: [],
      requiredRule: [(v) => !!v || 'Campo requerido']
    }
  },

  computed: {
    ...mapState('area', ['allAreas']),
    classificationOptions() {
      return this.selectedArea?.classifications || []
    }
  },

  watch: {
    value(newVal) {
      if (newVal === null) {
        this.selectedArea = null
        this.selectedClassification = null
        this.subtypeLevels = []
      }
    }
  },

  created() {
    this.fetchAreas()
  },

  methods: {
    ...mapActions('area', ['listAllAreas']),

    async fetchAreas() {
      this.loadingArea = true
      const { ok } = await this.listAllAreas({ onTree: true })
      if (!ok) {
        $EventBus.$emit('showSnack', 'error', 'No se pudo cargar las áreas')
      }
      this.loadingArea = false
    },

    handleAreaChange() {
      this.selectedClassification = null
      this.subtypeLevels = []
      this.emitChange(null)
    },

    handleClassificationChange() {
      this.subtypeLevels = []
      if (this.selectedClassification?.subtypes?.length) {
        this.addLevel(this.selectedClassification.subtypes)
      } else {
        this.emitChange(null)
      }
    },

    handleSubtypeChange(levelIndex) {
      this.subtypeLevels.splice(levelIndex + 1)

      const level = this.subtypeLevels[levelIndex]
      if (level?.selected?.children?.length) {
        this.addLevel(level.selected.children)
      }

      const lastSelected = this.subtypeLevels
        .slice()
        .reverse()
        .find(l => l.selected)

      this.emitChange(lastSelected ? lastSelected.selected : null)
    },

    addLevel(options) {
      this.subtypeLevels.push({ selected: null, options })
    },

    emitChange(newSubtype) {
      this.$emit('input', newSubtype)
    }
  }
}
